var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8798)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8798)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0518 9.3779C8.8311 8.4961 9.4551 7.5146 9.3789 6.435C9.3716 6.3252 9.3731 6.2153 9.3657 6.1069C9.3613 6.0542 9.4009 6.0088 9.4551 6.0044C9.4873 6.0029 9.5181 6 9.5488 6C11.8955 6 13.7983 7.8164 13.7983 10.0561C13.7983 10.2246 13.7866 10.3887 13.7647 10.5513C13.7529 10.6406 13.8584 10.6933 13.9229 10.6304C14.5996 9.977 15.0464 9.1084 15.1357 8.1372C15.1416 8.0698 15.2163 8.0303 15.2778 8.0654C16.8364 8.9809 17.8779 10.6186 17.8779 12.4936C17.8779 14.6367 16.5171 16.4765 14.5747 17.269C14.2231 17.4126 13.832 17.4331 13.4658 17.3276C12.6265 17.0874 11.8325 16.6435 11.1675 15.9975C10.9185 15.7544 10.7017 15.4922 10.5098 15.2182C10.4658 15.1538 10.3677 15.1684 10.3442 15.2402C10.1465 15.813 10.0527 16.4106 10.0615 17.0097C10.063 17.0801 9.9897 17.1269 9.9253 17.0962C8.1895 16.2275 7 14.4961 7 12.4936C7 11.3774 7.353 10.3037 7.9814 9.457",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8798",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/Popular.16c23e7a92742664521de17d0a0861f3.svg";
export { ForwardRef as ReactComponent };